<template>
  <div class="user-contact-chat mt-1">

    <div class="scrolling-wrapper-x pl-3" ref="scrollbox">
      <div class="user-contact-chat__chatbox">
        <div class="scrolling-spacer" />

        <div
          v-for="(message, index) in messagesCombined"
          :key="message.$key"
          :class="{
            // 'card': true,
            'px-1 pt-1': true,
            'message--sender-other': message.senderUserId !== myUserId,
            'message--sender-me': message.senderUserId === myUserId
          }">

          <chat-item-text
            ref="message"
            :message="message"
            :other-user-status="otherUserStatus"
            :my-user-status="myUserStatus"
            :contact-id="contactId"
            :groupable="isGroupable(messagesCombined[ index - 1 ], message)" />

          <span class="d-none">
            <!-- INFO: once it's rendered, it has been seen -->
            {{onMarkMessageAsSeen(message)}}
          </span>

          <div v-if="isDayChange(message, messagesCombined[ index + 1 ])" style="position: relative">
            <!-- DAYBREAK -->
            <hr class="m-3" />
            <span class="user-contact-chat__daybreak">{{message.createdAt.clone().add(1, 'days')|longDate}}</span>
          </div>

        </div>

        <!--
        <div>
          <el-input type="textarea" v-model="message"></el-input>
          <el-button @click="onSendMessage" class="mt-1">Send message</el-button>
          <el-button @click="onSendAdhocTask" class="mt-1">Send new task</el-button>
        </div>
        -->
      </div>
    </div>

    <div class="mx-3 pt-1">
      <!-- TODO: Support multi line text -->
      <el-input
        :placeholder="'Send message to ' + otherUserStatus.displayName"
        v-model="new_message"
        @keydown.native.enter="onSendMessage"
        class="input-with-select">
        <el-popover
          slot="prepend"
          placement="top-start"
          width="200"
          v-model="advanced_send_visible"
          trigger="manual">
          <div>
            <el-button
              title="Send new task"
              class="btn-block ml-0"
              @click.prevent="onSendAdhocTask">
              <!-- <font-awesome-icon icon="trash" class="taskicon" /> -->
              <i class="el-icon-chat-square"></i>
              Send new task
            </el-button>
            <el-button
              title="Send existing task"
              class="btn-block ml-0"
              @click.prevent="onSendTask">
              <i class="el-icon-chat-dot-square"></i>
              Send existing task
            </el-button>
            <!-- el-icon-chat-round -->
            <!-- el-icon-chat-line-square -->
          </div>
          <el-button slot="reference" @click="advanced_send_visible = !advanced_send_visible">
            <i class="el-icon-plus"></i>
          </el-button>
        </el-popover>

        <el-popover
          slot="suffix"
          placement="top-start"
          v-model="emojimart_visible"
          trigger="manual">
          <button class="ellipsis-button__close close px-2" aria-label="Close" @click="emojimart_visible = false">
            <span aria-hidden="true">&times;</span>
          </button>
          <!-- TODO: Very slow !! -->
          <picker v-if="emojimart_visible" class="mt-4" @select="onAddEmoji" />
          <span
            slot="reference"
            class="clickable el-input__icon el-icon-sugar"
            @click="onClickEmoji" />
        </el-popover>

        <!--
        <span
          class="el-input__icon el-icon-sugar"
          slot="suffix"
          @click="onClickEmoji" />
        -->
        <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->

      </el-input>
    </div>

    <!-- <pre class="mini-pre">messagesCombined: {{messagesCombined}}</pre> -->
    <!-- <pre class="mini-pre">outgoingMessages: {{outgoing_messages}}</pre> -->
  </div>
</template>

<script>
import { Picker } from 'emoji-mart-vue'
import util from '@/util'
import notificationSound from "@/assets/sounds/file-sounds-1101-plucky.mp3";
import ChatItemText from './Elements/ChatItemText'
import DropTaskPrompt from '@/components/Mixins/Prompts/DropTaskPrompt'

// TODO: Hide chat what user has not accepted friend request (and therefor can not receive messages)

// xTODO: Only show one item from list
// xTODO: Set numUnreadMessages to 0
// xTODO: use server time !!!

export default {
  mixins: [ DropTaskPrompt ],
  props: {
    contactId: {
      required: false,
    },
    showChat: {
      default: true
    },
  },
  data: () => ({
    emojimart_visible: false,
    advanced_send_visible: false,
    new_message: '',
  }),
  created() {
    this.sound = new Audio(notificationSound)

    this.$api.contact_add_if_not_cached( this.contactId );
    this.$api.contact_add_if_not_cached( this.myUserId );
  },
  mounted() {
    this.scrollToBottom();
  },
  watch: {
    numOfMessagesIncomming(newVal, oldVal) {
      if ( this.incommingMessages.$readyAll && newVal > oldVal ) {
        this.sound.play()
      }
    },
    numOfMessages(newVal, oldVal) {
      if ( newVal > oldVal ) {
        this.scrollToBottom();
      }
    }
  },
  computed: {

    myUserId() {
      return this.$models.user.defaultUserId;
    },

    myUserStatus() {
       // return this.$models.userSettings.getters.get_profile_pic
      return this.$models.userContact.get_contact_by_id( this.myUserId ) || {
        displayName: 'loading...',
        profilePic: null
      }
    },

    otherUserStatus() {
      return this.$models.userContact.get_contact_by_id( this.contactId ) || {
        displayName: 'loading...',
        profilePic: null
      }
    },

    myContactInformationAboutOtherUser() {
      return this.$models.userContact.subscribeNode( this.contactId )
    },

    outgoingMessages() {
      // TODO: We can not filter or limit here, because query is used for the user :-(
      return this.$models.userMsgInbox
        .with({ uid: this.contactId })
        .subscribeQuery({
          key: 'senderUserId',
          value: this.myUserId,
          limit: -101,
        })
    },

    incommingMessages() {
      // TODO: subscribeQuery
      // TODO: Limit to n entries
      // TODO: Implemente pagination (like telegram)

      // TODO: Why subscribe - old messages won't change anymore

      // TODO: Fetch 101 to check if there is more to load

      return this.$models.userMsgInbox.subscribeQuery({
          key: 'senderUserId',
          value: this.contactId,
        limit: -101,
      });

      /* .subscribeQuery({}) */
    },

    ready() {
      return this.outgoingMessages.$readyAll && this.incommingMessages.$readyAll
    },

    messagesCombined() {
      return [].concat(
          this.incommingMessages.itemsAsArray().filter(item => item.senderUserId === this.contactId),
          this.outgoingMessages.itemsAsArray()
        )
        .sort(util.sorter.by_createdAt)
    },

    numOfMessagesIncomming() {
      return this.incommingMessages.itemsAsArray().length;
    },

    numOfMessages() {
      return this.messagesCombined.length;
    },
  },
  methods: {

    isDayChange(message1, message2) {
      if ( !message2 ) {
        return
      }

      let date1 = message1.createdAt.clone().startOf('day')
      let date2 = message2.createdAt.clone().startOf('day')

      return date2.diff( date1, 'days') > 0
    },

    isGroupable(message1, message2) {
      if ( !message1 || !message2 ) {
        return false;
      }

      return message2.createdAt.diff( message1.createdAt, 'minutes') < 5
    },

    onSendMessage() {

      this.$api.contact_send_message({
        receiverUserId: this.contactId,
        message: this.new_message,
      }).then(() => {
        this.new_message = '';
        this.show_message_modal = false;
        // this.$message('Message sent')
      })

      // this.$models.userMsgInbox.with({ uid: this.contactId }).add({
      //   senderUserId: this.$models.user.defaultUserId,
      //   message: this.new_message,
      // })
      this.scrollToBottom();
    },

    onSendTask() {
      // console.log("onSendTask")

      if ( !this.checkIfTaskSendingIsAllowed() ) {
        return
      }

      this
        .$task_drop_prompt({ data: null, contactId: this.contactId })
        .then(({ config, done }) => {

          if ( !config.task || !config.task.taskId ) {
            done();
            return;
          }

          console.log("onSendTask: config", config)

          let payload = {
            receiverUserId: config.receiverUserId,
            message:        config.message,
            taskId:         config.task.taskId,
            goalId:         config.task.goalId,
            memberId:       config.task.memberId,
            commitmentId:   config.task.commitmentId, // REMOVE
          };

          let send_task = config.copy
            ? this.$api.contact_send_task_copy
            : this.$api.contact_send_existing_task;

          send_task(payload)
          .then(() => {
            done()
            this.scrollToBottom();
          }).catch(err => {
            this.$message.error(err.message)
            done();
          });
        })
    },

    async onSendAdhocTask() {
      // console.log("onSendAdhocTask")

      if ( !this.checkIfTaskSendingIsAllowed() ) {
        return
      }

      // Send task
      await this.$api.contact_send_new_task({
        receiverUserId: this.contactId,
      })

      // ...then hide menu
      this.advanced_send_visible = false;

      // ...and then focus on title
      this.$nextTick(() => {
        // TODO: What if tasks does not exist yet?
        let last_entry = this.$refs.message[ this.$refs.message.length - 1 ];
        last_entry.focus();

        // ... finally scroll to bottom
        this.scrollToBottom();
      })
    },

    checkIfTaskSendingIsAllowed() {
      console.log("checkIfTaskSendingIsAllowed", this.myContactInformationAboutOtherUser)

      // MOVE: TaskManagement Mixin ?
      let contact_info = this.myContactInformationAboutOtherUser;
      if ( !contact_info.$ready ) {
        console.warn("Contact info not ready");
        return false;
      }

      if ( !contact_info.allowDropTasks ) {
        this.$message.warning('User disabled the task inbox.')
        return false;
      }
      return true;
    },

    onAddEmoji(e) {
      console.log("onAddEmoji", e)
      this.new_message += e.native;
      // this.new_message += e.colons;
    },

    onClickEmoji() {
      this.emojimart_visible = !this.emojimart_visible;
    },

    onMarkMessageAsSeen(message, unread = false) {
      // TODO: Optimize: Use batch update instead
      if ( message.senderUserId !== this.myUserId && message.unread ) {
        message.update({ unread })
      }
      // Set message count to zero
      if ( this.myContactInformationAboutOtherUser.numNewMessages > 0 ) {
        this.$models.userContact.update( this.contactId, { numNewMessages: 0 });
      }
      return 'read'
    },

    scrollToBottom() {
      let height = this.$refs.scrollbox.firstElementChild.scrollHeight + 15;
      this.$nextTick(() => {
        this.$refs.scrollbox.scrollTo(0, height)
      })
    },
  },
  components: {
    Picker,
    ChatItemText,
  }
};
</script>

<style>
.scrolling-wrapper-x {
  /*border: 2px solid blue;*/
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  height: calc(100vh - 168px);
}
.scrolling-spacer {
  /*border: 2px solid green;*/
  flex-grow: 1;
}
.user-contact-chat__chatbox {
  /*border: 2px solid red;*/
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 1.5em;
}
.message--sender-other,
.message--sender-me {
  position: relative;
}
.user-contact-chat__daybreak {
  position: absolute;
  left: 0;
  top: -10px;
  text-align: center;
  background: white;
  padding-right: 15px;
  font-size: 9pt;
  color: #94989c;
}
</style>
